import React, { forwardRef, useCallback, useState } from "react";
import { UserMenu, useAuthProvider } from "react-admin";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import {
  Dialog,
  DialogTitle,
  Divider,
  ListItemIcon,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import classNames from "classnames";
import { ChangeFleetManagerPasswordForm } from "./ChangeFleetManagerPasswordForm";
import { stopPropagationForTab } from "../../common/util/stopPropagationForTab";
import { AuthManager } from "../../common/auth/Auth";
import { LoginAsCustomerCommand } from "./LoginAsCustomerCommand";
import { useAppData } from "../../common/hooks/useAppData";

interface IChangePasswordCommandProps {
  onClick?: any;
  className?: string;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      color: theme.palette.text.secondary,
    },
    active: {
      color: theme.palette.text.primary,
    },
    icon: { minWidth: theme.spacing(5) },
  }),
  { name: "RaMenuItemLink" }
);

const ChangePasswordCommand = forwardRef<HTMLLIElement>(
  ({ onClick, className, ...rest }: IChangePasswordCommandProps, ref) => {
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const handleMenuClick = useCallback(() => {
      setDialogOpen(true);
    }, []);

    const handleClose = useCallback(() => {
      setDialogOpen(false);
      onClick();
    }, [onClick]);

    return (
      <>
        <MenuItem
          className={classNames(classes.root, className)}
          ref={ref}
          tabIndex={0}
          {...rest}
          onClick={handleMenuClick}>
          <ListItemIcon className={classes.icon}>
            <VpnKeyIcon titleAccess="Change password" />
          </ListItemIcon>
          Change password
        </MenuItem>
        <Dialog
          open={dialogOpen}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth
          onKeyDown={stopPropagationForTab}>
          <DialogTitle>Change password</DialogTitle>
          <Divider />
          <ChangeFleetManagerPasswordForm onFinished={handleClose} />
        </Dialog>
      </>
    );
  }
);

const ProLogsUserMenu = (props: any) => {
  const authProvider = useAuthProvider() as AuthManager;
  const isOverridden = authProvider.isUserOverride();
  const tenants = useAppData((x) => x.tenants) ?? [];

  return (
    <div className="prologs-user-menu">
      <UserMenu {...props}>
        {isOverridden || (tenants.length && isOverridden) ? (
          <LoginAsCustomerCommand isOverridden={false} />
        ) : null}
        {isOverridden || tenants.length ? (
          <LoginAsCustomerCommand isOverridden={isOverridden} />
        ) : null}
        {tenants.length ? <Divider /> : null}
        <ChangePasswordCommand />
        <Divider />
      </UserMenu>
    </div>
  );
};

export default ProLogsUserMenu;
